export const WebUiSummaryEnI18n = {
    frequency: 'Frequency',
    numOfShares: 'Number of shares',
    paymentMethodFee: 'Payment method fee',
    pricePerShare: 'Price per share',
    title: 'Summary',
    total: 'Total',
    transactionFee: 'Transaction fee',
    transactionFeePopover:
        'This is a due diligence fee paid to cover costs associated with investigating, evaluating and purchasing underlying portfolio assets',
};
